<template>
<div>
  <div>
    <loader v-model=status.loading></loader>
    <arksnackbar v-model="status"></arksnackbar>
    <confirm ref="confirm"></confirm>
  </div>
  <div>
    <v-layout row justify-center>
      <customdialog v-model="dialog" :maxWidth="options.width" title="Profil Seçimi" :cardtextstyle="'height: 420px;'">
        <template slot="header">
          <v-card-title>
            <v-select hide-details label="Profil Şablonu" v-model="sablonTipId" :items="sablonTipList" outline item-text="SAblonAdi" item-value="SablonId" v-on:change="sablonChange()">
            </v-select>

            Profil No : {{profilId}}
            <v-btn margin="6px 8px" icon color="primary" @click.stop="profilAra()">
              <v-icon>search</v-icon>
            </v-btn>

          </v-card-title>
        </template>

        <v-form ref="profilKayit" v-model="valid" lazy-validation>
          <div>
            <profilelement v-for="item in profilSablonValue" :profil="item" :key="item.Id" />
          </div>
        </v-form>

        <template slot="btn">
          <v-btn color="primary" flat @click.native="yes()">KAYDET</v-btn>
        </template>

      </customdialog>
    </v-layout>
  </div>

  <!-- Arama Dialog -->

  <customdialog v-model="dialogAra" :maxWidth="options.width" title="Profil Arama" :cardtextstyle="'height: 420px;'">
    <template slot="header">
      <v-card-title>
        <v-autocomplete hide-details label="Arama Kriteri" solo outline v-model="aramakriter" :items="profilSablonValue" item-text="AlanAdi" item-value="Id" return-object clearable></v-autocomplete>
        <v-text-field ref="aramatext" solo outline hide-details v-model="aranacak" label="Ara" append-outer-icon="refresh" append-icon="search" @click:append-outer="yenile();" v-on:keyup.13="yenile();"></v-text-field>
      </v-card-title>
    </template>

    <!-- Begin Data Table ************************************************************************************-->
    <div class="flex md12">
      <v-data-table :headers="tableheaders" :items="tableitems" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr @click="yesAraId(props.item.Id)">
            <td v-for="tableheader in tableheaders" :key="tableheader.id">
              {{props.item[tableheader.value]}}
            </td>
          </tr>
        </template>

      </v-data-table>
    </div>
    <!-- End Data Table *************************************************************************************** -->

    <template slot="btn">
      <v-btn color="primary" flat @click.native="yesAra()">KAYDET</v-btn>
    </template>

  </customdialog>

</div>
</template>

<script>
import profilelement from "@/components/app/coper/comp/profilelement.vue";

import confirm from "@/components/app/coper/comp/confirm.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";

import tool from "../tools";

export default {
  data() {
    return {
      ilk: false,
      dialog: false,
      dialogAra: false,
      aramakriter: null,
      status: tool.NewSatatus(),
      tableheaders: [{
          text: 'ID',
          align: 'left',
          sortable: false,
          value: 'Id'
        },

      ],
      tableitems: [],

      aranacak: null,

      resolve: null,
      reject: null,

      resolveAra: null,
      rejectAra: null,

      profilId: 0,
      sablonTipList: [],
      sablonTipId: null,
      profilSablonValue: [],

      valid: true,

      options: {
        color: "primary",
        width: 800,
        message: null
      }
    };
  },
  components: {
    profilelement,
    confirm,
    arksnackbar,
    loader,
    customdialog,
  },

  methods: {
    open(profilId, options) {
      this.ilk = true;
      this.dialog = true;
      this.profilId = profilId;

      if (this.sablonTipList.length == 0) {
        this.getSablonTipList();
      } else {

        this.getSablonId(profilId);
      }

      this.getProfilSablonValue(this.profilId, this.sablonTipId);

      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    openAra() {

      this.dialogAra = true;
      return new Promise((resolveAra, rejectAra) => {
        this.resolveAra = resolveAra;
        this.rejectAra = rejectAra;
      });
    },

    yes() {
      if (this.$refs.profilKayit.validate()) {
        this.profilKaydet();
      }
    },
    cancel() {
      if (this.dialogAra == false) {
        this.resolve({
          ok: false
        });
        this.dialog = false;
      }
    },

    yesAra() {
      this.resolveAra({
        ok: true,
        profilId: this.tableitems[0].Id,
      });
      this.dialogAra = false;
    },
    yesAraId(id) {
      this.resolveAra({
        ok: true,
        profilId: id,
      });
      this.dialogAra = false;
    },

    cancelAra() {
      this.resolveAra({
        ok: false
      });
      this.dialogAra = false;
    },

    getSablonTipList: getSablonTipList,
    getSablonId: getSablonId,
    getProfilSablonValue: getProfilSablonValue,
    sablonChange: sablonChange,
    profilKaydet: profilKaydet,
    profilAra: profilAra,
    yenile: yenile,

  }
};

function yenile() {

  var prm = {
    sablonId: this.sablonTipId,
    kriter: this.aramakriter,
    aranacak: this.aranacak,
  }

  this.status.loading = true;
  tool.http_post(this, "GetProfilList", prm).then(
    response => {
      this.tableheaders = [];

      var i;
      for (i = 0; i < this.profilSablonValue.length; i++) {
        var h = {
          text: this.profilSablonValue[i].AlanAdi,
          value: this.profilSablonValue[i].AlanId
        }
        this.tableheaders.push(h);
      }

      this.tableitems = response.body;

      this.status.loading = false;
      //this.status.show = true;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function profilAra() {

  this.openAra().then(profildialogAra => {
    if (profildialogAra.ok) {
      this.profilId = profildialogAra.profilId;
      this.getProfilSablonValue(this.profilId, this.sablonTipId);

    }

  });
}

function sablonChange() {

  this.tableheaders = [];
  this.tableitems = [];

  if (this.ilk == true) {
    this.ilk = false;
  } else {
    this.profilId = 0;
  }

  this.getProfilSablonValue(this.profilId, this.sablonTipId);
}

function getSablonTipList() {
  this.status.loading = true;
  tool.http_post(this, "SablonTipList", null).then(
    response => {
      this.sablonTipList = response.body;
      this.getSablonId(this.profilId);
      this.status.loading = false;
      //this.status.show = true;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );

}

function getSablonId(val) {
  if (val > 0) {
    this.status.loading = true;
    tool.http_post(this, "getSablonId", {
      id: val
    }).then(
      response => {
        this.sablonTipId = response.body;
        this.status.loading = false;
        //console.log("getSablonId response.body:");
        //console.log(response.body);

      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  }
}

function getProfilSablonValue(profilID, sablonID) {
  this.status.loading = true;
  tool.http_post(this, "profilSablonValue", {
    profilID: profilID,
    sablonID: sablonID
  }).then(
    response => {
      //console.log(response.body);
      //this.sablonTipId = response.body[0].SablonID;

      this.profilSablonValue = response.body;
      this.status.loading = false;
      this.aramakriter = this.profilSablonValue[0];

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function profilKaydet() {

  var prm = {
    profilId: this.profilId,
    sablonTipId: this.SablonTipId,
    profilSablonValue: this.profilSablonValue
  }

  this.status.loading = true;
  tool.http_post(this, "profilKaydet", prm).then(
    response => {
      //console.log(response.body);
      var f_profilId = response.body;
      this.status.loading = false;
      this.resolve({
        id: f_profilId,
        ok: true,
      });
      this.dialog = false;

    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}
</script>
